import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideTabsConfig } from 'ng-primitives/tabs';

export function provideTabGroup(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTabsConfig({
      orientation: 'horizontal',
      activateOnFocus: true,
      wrap: false,
    }),
  ]);
}
